// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck These are copy+pasted scripts for 3rd party analytics.

export function addFbq(window: Window) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n = f.fbq = function(){n.callMethod ?
n.callMethod.apply(n,arguments) : n.queue.push(arguments);};if(!f._fbq)f._fbq = n;
        n.push = n;n.loaded = !0;n.version = '2.0';n.queue = [];t = b.createElement(e);t.async = !0;
        t.src = v;s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
}

export function addGA(window: Window) {
    /* eslint-disable */
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function(){
        (i[r].q = i[r].q || []).push(arguments);},i[r].l = 1 * new Date();a = s.createElement(o),
    m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a,m);
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
}

export function addGA4(window: Window) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {window.dataLayer.push(arguments);};
    window.gtag('js', new Date());

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-EFZJPJ84N1';
    document.head.appendChild(script);
}
